import { render } from "./PaymentStatusPage.vue?vue&type=template&id=6b9afb9c&scoped=true"
import script from "./PaymentStatusPage.vue?vue&type=script&lang=js"
export * from "./PaymentStatusPage.vue?vue&type=script&lang=js"

import "./PaymentStatusPage.vue?vue&type=style&index=0&id=6b9afb9c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9afb9c"]])

export default __exports__